import React from "react";

import { Box, Grid, Typography } from "@mui/material";

import "../styles/book.css";

const Book = ({
    image,
    url,
    name,
    author,
    subline,
    textInside = "Cómpralo",
}) => {
    return (
        <Grid
            container
            direction={{ sm: "column", md: "row" }}
            spacing={2}
            sx={{
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
            }}
        >
            <Grid size={{ xs: 12, md: 6 }}>
                <figure className="book align">
                    {/* <!-- Front --> */}

                    <ul className="hardcover_front">
                        <li>
                            <div
                                className="coverDesign portada"
                                style={{
                                    backgroundImage: `url(${image})`,
                                }}
                            ></div>
                        </li>
                        <li></li>
                    </ul>

                    {/* <!-- Pages --> */}

                    <ul className="page">
                        <li></li>
                        <li>
                            <a className="btn" href={url} target="_blank">
                                {textInside}
                            </a>
                        </li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>

                    {/* <!-- Back --> */}

                    <ul className="hardcover_back">
                        <li></li>
                        <li></li>
                    </ul>
                    <ul className="book_spine">
                        <li></li>
                        <li></li>
                    </ul>
                </figure>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} sx={{ minWidth: 0 }}>
                <Box
                    sx={{
                        minWidth: 0,
                        textAlign: { xs: "center", md: "left" },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: { xs: "center", md: "flex-start" },
                    }}
                >
                    <Typography
                        component="h2"
                        sx={{
                            fontSize: { xs: "1.6rem", md: "1.85rem" },
                            fontWeight: 600,
                            lineHeight: 1.1,
                            letterSpacing: "-.025em",
                            maxWidth: 300,
                        }}
                    >
                        {name}
                    </Typography>

                    <Typography
                        sx={{
                            mt: 1,
                            fontSize: ".78rem",
                            letterSpacing: ".12em",
                            textTransform: "uppercase",
                            color: "rgba(255,255,255,.45)",
                        }}
                    >
                        {author}
                    </Typography>

                    <Typography
                        sx={{
                            mt: 2,
                            color: "rgba(255,255,255,.65)",
                        }}
                    >
                        {subline}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );
};

export default Book;
